import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as ResumeIOIcon } from './resumeIO.svg';

export const ResumeIO = IconHOC(ResumeIOIcon);
